import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AccountRepository from '@/shared/http/repositories/access/account.js'
import GroupRepository from '@/shared/http/repositories/configurations/group.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import AccountMixin from '@/store/module/account/mixin'

const LeadOwnerForm = {
  responsaveis: {
    value: [],
    options: [],
    required: false,
    state: null
  },
  gruposResponsaveis: {
    value: [],
    options: [],
    required: false,
    state: null
  }
}
const LeadOwnerModel = {
  'boardColumnId': null,
  'motivoPerdaId': null,
  'origemLeadId': null,
  'pessoaId': null,
  'posicao': 0,
  'situacao': 0,
  'reativado': 0,
  'dataCriacao': null,
  'dataInicioSituacao': null,
  'dataReativacao': null,
  'responsaveis': [],
  'gruposResponsaveisId': []
}

export default {
  name: 'CrmDetailsLeadOwner',
  mixins: [ActionsForm, AccountMixin],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    cardActive: {
      type: Boolean,
      default: true
    },
    alterarResponsavel: {
      type: Boolean
    }
  },
  data () {
    return {
      data: LeadOwnerModel,
      form: LeadOwnerForm,
      notEdit: false,
      oldUsersOwners: [],
      oldGroupsOwners: []
    }
  },
  watch: {
    card () {
      if (this.card && this.card.pessoa) {
        this.onSyncData()
      }
    }
  },
  mounted () {
    this.onLoadAllAccount()
    this.onLoadAllGroups()
    this.onSyncData()
    this.notEditResponsavel()
  },
  methods: {
    onLoad () {},
    onSyncData () {
      if (this.card) {
        if (this.card.responsaveis) {
          this.form.responsaveis.value = this.card.responsaveis.map(responsavel => responsavel.usuario.id) || []
          this.oldUsersOwners = this.form.responsaveis.value
        }
        if (this.card.gruposResponsaveis) {
          this.form.gruposResponsaveis.value = this.card.gruposResponsaveis.map(grupoResponsavel => grupoResponsavel.grupo.id) || []
          this.oldGroupsOwners = this.form.gruposResponsaveis.value
        }
      }
    },
    onLoadAllAccount () {
      loading.push()
      AccountRepository.GetAllName()
        .then((response) => {
          loading.pop()
          this.form.responsaveis.options = response.data.content.map(usuario => {
            return ({ 'text': usuario.nomePessoa, 'value': usuario.id })
            // if (usuario.nomePessoa) {
            // } else {
            //   return ({ 'text': usuario.userName, 'value': usuario.id })
            // }
          })
        })
        .catch((err) => {
          console.log(err)
        })
        // catch(this.onException)
    },
    onLoadAllGroups () {
      loading.push()
      GroupRepository.GetAllActive()
        .then(response => {
          loading.pop()
          this.form.gruposResponsaveis.options = response.data.content.map(group => ({ 'text': group.nameGroup, 'value': group.id }))
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onLoadCardSyncDb (card) {
      if (card) {
        this.data.id = card.id
        this.data.boardColumnId = (card.boardColumn ? card.boardColumn.id : null)
        this.data.motivoPerdaId = card.motivoPerda ? card.motivoPerda.id : null
        this.data.posicao = card.posicao
        this.data.situacao = card.situacao
        this.data.countReativado = card.countReativado
        this.data.dataCriacao = card.dataCriacao
        this.data.dataInicioSituacao = card.dataInicioSituacao
        this.data.dataReativacao = card.dataReativacao
        this.data.origemLeadId = card.origemLead ? card.origemLead.id : null
        this.data.pessoaId = card.pessoa ? card.pessoa.id : null
      }
    },
    onUpdateCard () {
      this.onLoadCardSyncDb(this.card)
      if (this.card) {
        loading.push()
        const data = {id: this.card.id, responsaveis: this.form.responsaveis.value, gruposResponsaveisId: this.form.gruposResponsaveis.value}
        BoardRepositoryV2.Card_PatchLeadOwner(
          this.card.boardColumn.board.id,
          this.card.boardColumn.id,
          this.card.id,
          data
        )
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              toast.success(this.$lang.Common.Alerts.Success)
              let messageFollowupUser = ''
              let messageFollowupGroup = ''
              this.$emit('updatedLeadOwners')

              if (this.oldUsersOwners !== this.form.responsaveis.value) {
                let ownerUserSet = new Set(this.form.responsaveis.value)
                let owner = this.form.responsaveis.options.filter(responsavel => ownerUserSet.has(responsavel.value)).map(responsavel => responsavel.text).join(', ')
                messageFollowupUser += `O(s) usuário(s) ${owner} foram definidos como responsáveis`
              }
              if (this.oldGroupsOwners !== this.form.gruposResponsaveis.value) {
                let ownerGroupSet = new Set(this.form.gruposResponsaveis.value)
                let owner = this.form.gruposResponsaveis.options.filter(responsavel => ownerGroupSet.has(responsavel.value)).map(responsavel => responsavel.text).join(', ')
                messageFollowupGroup += `${messageFollowupUser ? ', e o(s)' : 'O(s)'} grupo(s) ${owner} foram definidos como responsáveis`
              }

              createNewFollowupWithCard(this.card.pessoa.document, 'sys_responsavel_adicionado', `${messageFollowupUser}${messageFollowupGroup}`, this.ip, this.latitude, this.longitude, this.card.id)
            }
          })
          .catch(this.onException)

        NotificationsCardRepository.Create({
          cardId: this.card.id,
          usuariosID: this.form.responsaveis.value,
          groupsID: this.form.gruposResponsaveis.value,
          agendamento: false
        })
          .then((response) => {
            loading.pop()
          })
          .catch(this.onException)
      }
    },
    notEditResponsavel () {
      if (this.account.permissoes.includes('ALTERAR_RESPONSAVEL')) {
        this.notEdit = false
        return
      }

      if (this.alterarResponsavel === true) {
        this.notEdit = true
        return
      }

      this.notEdit = false
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/leadowner/leadowner.js